import { Injectable } from '@angular/core';
import { CanActivateChild } from '@angular/router';

import { AuthService, AuthGuard } from '../../core';
import { UsuarioPerfil, usuarioPerfilAdministrador, usuarioPerfilAtendente, usuarioPerfilGerente } from '../usuario/usuario-perfil';


/** Acessos permitidos ao cadastro de tabelas de preços */
export const acessosTabelaPreco: UsuarioPerfil[] = [usuarioPerfilAdministrador, usuarioPerfilGerente, usuarioPerfilAtendente];

@Injectable()
export class CanActivateTabelaPreco implements CanActivateChild {

    constructor(private authGuard: AuthGuard,
                private authService: AuthService) { }

    canActivateChild(): boolean {
        // Somente se o usuário possuir acesso ao recurso de tabelas de preços
        if (!this.authService.podeAcessarTabelasPrecos()) {
            return false;
        }


        return this.authGuard.canActivateAcesso(acessosTabelaPreco);
    }
}
